import {
  Box,
  Breadcrumbs,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { SelectField2 } from "../../../components/Form";
import InputField from "../../../components/Form/InputField";
import TextAreaField from "../../../components/Form/TextAreaField";
import { useNavigate } from "react-router-dom";
import {
  useGetByIdTrainingQuery,
  useUpdateTrainingMutation,
} from "../../../store/training/TrainingAPI";
import { useGetTrainingTypesQuery } from "../../../store/dropdown/dropdownApi";
import { useForm } from "react-hook-form";
import { BackdropLoader } from "../../../components/General";
import Swal from "sweetalert2";
import { ColorModeContext } from "../../../constants/theme";
import { SaveAndCancelBtn } from "../../../components";

const breadcrumbs = [
  <Typography className="tw-text-[11px]" key="100">
    Trainings
  </Typography>,
  <Typography className="tw-text-dark-blue tw-text-[11px]" key="200">
    Edit trainings
  </Typography>,
];
const EditInitativeTraining = () => {
  const { mode } = useContext(ColorModeContext);
  const url = window.location.href;
  const ID = url.substring(url.lastIndexOf("/") + 1);
  const { data, isSuccess: locSuccess } = useGetByIdTrainingQuery(ID);
  const [
    updateTraining,
    { isSuccess: updateSuccess, isLoading: updateLoading },
  ] = useUpdateTrainingMutation();
  const { data: trainingTypeData } = useGetTrainingTypesQuery();
  const navigate = useNavigate();

  const { register, handleSubmit, control, reset } = useForm({
    mode: "onSubmit",
    criteriaMode: "firstError",
    reValidateMode: "onSubmit",
  });

  useEffect(() => {
    if (locSuccess) {
      console.log("training data ---->", data);
      const obj = { ...data.training };
      console.log(obj);
      reset(obj);
    }
    if (updateSuccess) {
      Swal.fire({
        icon: "success",
        title: "Training data updated Successfully!",
        showConfirmButton: false,
        timer: 1000,
      });
      navigate("/home/training");
    }
  }, [locSuccess, updateSuccess]);

  const onSubmit = (data) => {
    console.log("onnsuvmit data", data);
    const obj = {};
    obj.training_type = data.training_type;
    obj.status = data.status;
    obj.pending_reason = data.pending_reason;
    obj.date = data.date;
    obj.mode_of_training = data.mode_of_training;
    obj.training_group = data.training_group;
    obj.inititative_name = data.inititative_name;
    obj.inititative_description = data.inititative_description;

    console.log("object", obj);
    updateTraining({ id: ID, body: obj });
  };

  return (
    <Box
      className="tw-p-10"
      sx={{
        height: "auto",
        width: "100%",
        maxWidth: "1300px",
        margin: 0,
        display: "flex",
        flexDirection: "column",
        gap: "30px",
        background: `${mode === "dark" ? "#0D0D0D" : "#FFFFFF"}`,
      }}
    >
      <Toolbar />
      <Box className="tw-flex tw-justify-start tw-space-x-3">
        <IconButton
          className="tw-rounded-lg tw-shadow-lg tw-w-14 tw-h-14"
          sx={{ background: `${mode === "dark" ? "#1A1A1A" : "#FFFFFF"}` }}
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box
          className="tw-flex-1 tw-rounded-lg tw-shadow-lg tw-py-3 tw-px-8"
          sx={{ background: `${mode === "dark" ? "#1A1A1A" : "#FFFFFF"}` }}
        >
          <Breadcrumbs
            sx={{
              display: "flex",
              height: "100%",
            }}
            separator={<NavigateNextIcon fontSize="small" />}
          >
            {breadcrumbs}
          </Breadcrumbs>
        </Box>
      </Box>
      {updateLoading && <BackdropLoader open={updateLoading} />}
      <Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box className="tw-rounded-3 tw-mb-4 sm:tw-mb-8">
            <Box className="tw-w-full tw-mb-4 sm:tw-mb-6 lg:tw-mb-12">
              <Typography
                className="tw-font-semibold heading1"
                sx={{ color: `${mode === "dark" ? "#FFF" : "#000"}` }}
              >
                Edit Trainings
              </Typography>
            </Box>

            <Box className="tw-w-80 tw-my-10">
              <SelectField2
                label={"Training Type"}
                placeholder={"Select"}
                name={"training_type_id"}
                register={register}
                menus={trainingTypeData?.trainingType}
                control={control}
              />
            </Box>
            <Box
              className="tw-p-3 sm:tw-p-6 lg:tw-p-12 tw-rounded-3 tw-mb-4 sm:tw-mb-8"
              sx={{
                background: `${mode === "dark" ? "#1A1A1A" : "#FFF6F2"}`,
              }}
            >
              <Box className="tw-w-80">
                <InputField
                  label={"Name of Initiative"}
                  placeholder="Initiative"
                  name={"inititative_name"}
                  register={register}
                />
              </Box>
              <Box className="tw-my-10 ">
                <TextAreaField
                  register={register}
                  label={"Initiative Description "}
                  placeholder={"Description"}
                  name={"description"}
                />
              </Box>
            </Box>
            <Box className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-justify-end tw-space-y-4 sm:tw-space-x-8 sm:tw-space-y-0 tw-mt-6 md:tw-mt-6 lg:tw-mt-16">
              <SaveAndCancelBtn
                handleCancle={() => {
                  navigate("/home/training");
                }}
              />
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default EditInitativeTraining;
